import { Request,BaseApiUrl } from "./api";

// 列表
export const getReturAndTransferRecordListPage = (params) => {
  return Request.get(`${BaseApiUrl}/api/ReturAndTransferRecord/get`, { params: params });
};
